if (!customElements.get('lakras-look-images')) {
  customElements.define('lakras-look-images', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.card = this.closest('.product-card-wrapper');
      this.media = this.card?.querySelector('.card__inner');
      this.images = this.card?.querySelectorAll('.card__media .media > img');
      this.buttons = this.querySelectorAll('[data-look-image]');
      if (!this.media || this.images.length < 2 || this.buttons.length !== 2) return;
      this.initialized = true;
      this.mobile = window.matchMedia('(max-width: 749px)');
      this.onButtonClick = (event) => {
        event.preventDefault();
        event.stopPropagation();
        this.setImage(Number(event.currentTarget.dataset.lookImage));
      };
      this.onPointerDown = (event) => {
        this.start = null;
        if (!this.mobile.matches || !['touch', 'pen'].includes(event.pointerType)) return;
        const rect = this.media.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right ||
            event.clientY < rect.top || event.clientY > rect.bottom) return;
        this.start = { x: event.clientX, y: event.clientY, id: event.pointerId };
      };
      this.onPointerUp = (event) => {
        if (!this.mobile.matches || !this.start || this.start.id !== event.pointerId) return;
        const dx = event.clientX - this.start.x;
        const dy = event.clientY - this.start.y;
        this.start = null;
        if (Math.abs(dx) < 35 || Math.abs(dx) <= Math.abs(dy) * 1.25) return;
        this.setImage(dx < 0 ? 1 : 0);
        this.suppressUntil = Date.now() + 600;
        event.preventDefault();
      };
      this.onPointerCancel = () => { this.start = null; };
      this.onCardClick = (event) => {
        if (!this.mobile.matches || this.contains(event.target)) return;
        if (Date.now() < (this.suppressUntil || 0)) {
          event.preventDefault();
          event.stopPropagation();
          this.suppressUntil = 0;
        }
      };
      this.onResize = () => {
        if (!this.mobile.matches) this.setImage(0);
      };
      this.buttons.forEach((button) => button.addEventListener('click', this.onButtonClick));
      this.card.addEventListener('pointerdown', this.onPointerDown);
      this.card.addEventListener('pointerup', this.onPointerUp);
      this.card.addEventListener('pointercancel', this.onPointerCancel);
      this.card.addEventListener('click', this.onCardClick, true);
      window.addEventListener('resize', this.onResize, { passive: true });
      if (!this.images[1].alt) this.images[1].alt = this.images[0].alt;
      this.setImage(0);
      this.setAttribute('data-ready', '');
    }

    setImage(index) {
      this.card.classList.toggle('lakras-look-second', index === 1);
      this.buttons.forEach((button, position) => {
        button.setAttribute('aria-pressed', position === index ? 'true' : 'false');
      });
      this.images.forEach((image, position) => {
        image.setAttribute('aria-hidden', position === index ? 'false' : 'true');
      });
      if (index === 1) this.images[1].loading = 'eager';
    }

    disconnectedCallback() {
      if (!this.initialized) return;
      this.buttons.forEach((button) => button.removeEventListener('click', this.onButtonClick));
      this.card.removeEventListener('pointerdown', this.onPointerDown);
      this.card.removeEventListener('pointerup', this.onPointerUp);
      this.card.removeEventListener('pointercancel', this.onPointerCancel);
      this.card.removeEventListener('click', this.onCardClick, true);
      window.removeEventListener('resize', this.onResize);
      this.card.classList.remove('lakras-look-second');
      this.initialized = false;
    }
  });
}
